import { JceHomepageGeographyTier } from 'generated/graphql';

export const TIER_ORDER: JceHomepageGeographyTier[] = [
  'TIER_ONE',
  'TIER_TWO',
  'TIER_WINE_REGION',
  'TIER_THREE',
];

export const TIER_LABELS: Record<JceHomepageGeographyTier, string> = {
  TIER_ONE: 'Tier 1',
  TIER_TWO: 'Tier 2',
  TIER_WINE_REGION: 'Tier Winery',
  TIER_THREE: 'Tier 3',
  TIER_UNSPECIFIED: 'Unspecified',
};
